import {http} from "Services/Http/HttpClient"
import {DropzoneFile} from "Components/FileUpload/FileUpload";

export const createFullInscriptionOrder = async (
    discountType: string = '',
    socialWorker: string = '',
    extraDiscountValue : string = '',
    unemployedTutor : string = '',
    legalDocsConsent: string = '',
    legalDocsFiles: DropzoneFile[] = []
): Promise<unknown> => {
    if (legalDocsFiles.length === 0) {
        return await http.post('inscription-orders/full', {
            discountType: discountType,
            socialWorker: socialWorker,
            extraDiscountValue: extraDiscountValue,
            unemployedTutor: unemployedTutor,
            legalDocsConsent: legalDocsConsent
        })
    }

    const data = new FormData()
    data.append('discountType', discountType)
    data.append('socialWorker', socialWorker)
    data.append('extraDiscountValue', extraDiscountValue)
    data.append('unemployedTutor', unemployedTutor)
    data.append('legalDocsConsent', legalDocsConsent)
    legalDocsFiles.forEach((dropzoneFile) => data.append('legalDocsFiles[]', dropzoneFile.file))

    return await http.post('inscription-orders/full', data, {
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

export const createInscriptionOrder = async (): Promise<unknown> => {
    return await http.post('inscription-orders')
}

export interface InscriptionOrderActivity {
    id: string,
    child: string,
    session: string,
    days: string[],
    services: string[],
    discountRequest: boolean
}

export const validateInscriptionBySocialServiceUser = async (
    id: string,
    approve: boolean
): Promise<any> => {
    return await http.post('/inscriptions/' + id + '/validate-inscription-by-social-service', {
        approve: approve
    })
}

export const validateInscriptionOrderActivityBySocialServiceUser = async (
    id: string,
    approve: boolean
): Promise<any> => {
    return await http.post(`/inscriptions-order-activity/${id}/validate-by-social-service`, {
        approve: approve
    })
}

export interface ModifySessionBody {
    newActivitySessionId: string
    initDate: string
    days: string[]
    services?: string[]
    observations?: string
}

export const modifyInscriptionOrderActivitySession = async (
    id: string,
    body: ModifySessionBody
): Promise<any> => {
    return await http.put(`inscription-order-activity/${id}/modify-session`, body)
}

export const updateInscriptionOrderActivityStatus = async (
    id: string,
    status: number
): Promise<any> => {
    return await http.put(`/inscriptions-order-activity/${id}/status`, { status })
}

export const removeInscriptionOrderActivityDay = async (
    id: string,
    dayId: string
): Promise<any> => {
    return await http.delete(`/inscriptions-order-activity/${id}/days/${dayId}`)
}

export const removeInscriptionOrderActivityService = async (
    id: string,
    serviceId: string
): Promise<any> => {
    return await http.delete(`/inscriptions-order-activity/${id}/services/${serviceId}`)
}

export const addServiceToInscriptionOrderActivity = async (
    id: string,
    day: string,
    service?: string
): Promise<any> => {
    return await http.post(`/inscriptions-order-activity/${id}/services`, { day, service })
}
